import script from "./UploadModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./UploadModal.vue?vue&type=script&setup=true&lang=ts"

import "./UploadModal.vue?vue&type=style&index=0&id=18738b3b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18738b3b"]])

export default __exports__